// 
// -----------------------------------------------------------------------------
(function ($nav) {
	if ($nav.length === 0) {return false;}

	$(window).on("scroll", function() {
	    if($(window).scrollTop() > 50) {
	    		if ($('.h-menu-mobile').hasClass('open')) {
	        	$nav.removeClass("active");
	    		} else {
	    			$nav.addClass("active");
	    		}
	    } else {
	       $nav.removeClass("active");
	    }
	});

})($( '.h-nav-wrap' ));

(function($mobNav){
	$(document).on('click', '.h-mobileNav', function(event) {

		event.preventDefault();
		var mobileMenu = $('.h-menu-mobile');
		var $this = $(this);
		var cartWrap = $('.shoppcart');
		var msearch = $('.msearch');

		if ($this.hasClass('open')) {
			$this.removeClass('open');
			mobileMenu.toggleClass('open');
			cartWrap.css('z-index', '9999');
			msearch.fadeOut(100);
		} else {
			$this.addClass('open');
			mobileMenu.toggleClass('open');
			cartWrap.css('z-index', '999');
			setTimeout(function(){
				msearch.fadeIn(200);
			}, 400);
		}

	});
})($('.h-menu-mobile'));

(function($msearch){
	$msearch.on('click', $msearch, function(event) {
		event.preventDefault();
		var searchField = $('.search-field');
		
		if (searchField.height() > 0) {
			searchField.height(0);
		} else {
			searchField.height(62);
		}
		
	});
})($('.msearch'));


	    if (matchMedia) {
	      var mq = window.matchMedia("(max-width: 991px)");
	      mq.addListener(WidthChange);
	      WidthChange(mq);
	    }

	    function WidthChange(mq) {

	      if (mq.matches) {
			(function($hassubmenu){
				$hassubmenu.click(function(event) {
					event.preventDefault();
					var submenu = $(this).find('.sub-menu');
					var height = (submenu.find('li').length * 45);

					if ($(this).hasClass('open')) {
						submenu.animate({height: '0px'}, 400);
						$(this).removeClass('open');
					} else {
						submenu.animate({height: height+'px'}, 400);
						$(this).addClass('open');
					}

				});
			})($('.menu-item-has-children'));
		}
	}

